import { Alert, Box, Button, Snackbar } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import { useModalContext } from "../ModalContext";
import AddNewPricelist from "./AddNewPricelist";
import TabComp from "../components/TabComp";
import { DcPriceListColDef } from "./DcPricelistColDef";
import PriceListRowData from "./PricelistRowData";
import { AccountPriceListColDef } from "./AccountPricelistColDef";
import AccountPriceListRowData from "./AccountRowData";
import { roundData } from "../helpers/currentMonthSummaryData";
import EditIcon from "@mui/icons-material/Edit";
import api from "../axiosConfig";
import AddIcon from "@mui/icons-material/Add";
import MultiplePriceListEdit from "./MultiplePriceListEdit";
import { getUser } from "../helpers";
import { fetchEditPermissions } from "../api/editpermissions";

function Pricelist({ open }) {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  // const [loading, setLoading] = useState(false);
  const { loading, data: initialACRowData } = PriceListRowData();
  const { loadingSpinner, data: initialDcRowData } = AccountPriceListRowData();
  const [rowData, setRowData] = useState(initialACRowData);
  const [rowData01, setRowData01] = useState(initialDcRowData);

  // column Defs
  const [DCcolDefs] = useState(DcPriceListColDef);
  const [AccountColDefs] = useState(AccountPriceListColDef);
  // Tab heading
  const tabLabels = ["DC Price", "Account Price"];
  const [activeTab, setActiveTab] = useState(0);
  const [multiEditModel, setMultiEditModel] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isEditing, setIsEditing] = useState();
  const [rowIndex, setRowIndex] = useState();
  //snackbar alert, filter ag table data
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [filteredData, setFilteredData] = useState([]);
  const [priceListResponse, setPriceListResponse] = useState();
  const [getDcMrpTax, setGetDcMrpTax] = useState();

  //find user, passing data using ref
  const gridRef = useRef(null);
  const user = getUser();

  //global context
  const {
    customOpenModal,
    setCustomOpenModal,
    closeModal,
    editingValue,
    currency,
    hasActiveFilters,
    setHasActiveFilters,
  } = useModalContext();

  //DcPriceListColDef
  useEffect(() => {
    setRowData(initialACRowData);
  }, [initialACRowData]);

  //account
  useEffect(() => {
    setRowData01(initialDcRowData);
  }, [initialDcRowData]);

  //edit permission
  useEffect(() => {
    const fetchPermission = async () => {
      const permissions = await fetchEditPermissions();
      setIsButtonEnabled(permissions.Current_Month === 1);
    };

    fetchPermission();
  }, []);

  //ag grid row click
  const handleRowClick = (event, type) => {
    const priceList = event.data?.Pricelist || "";
    const productCode = event.data?.ProductCode || "";
    // setSelectedRowData({ ...event.data, type }); // Add type to identify type of priceList
    // setCustomOpenModal(true);

    // Clear the previous price list data before making a new API call
    setPriceListResponse(null);

    setMultiEditModel(true);
    setIsEditing(true);

    // hit Api
    const apiEndpoint = "/api/getaccountpricelist";
    // API endpoint
    api
      .post(apiEndpoint, {
        body: {
          Pricelist: priceList,
          ProductCode: productCode,
          page: "pricelist",
          user: user,
          currencyType: currency,
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);
        setPriceListResponse(response.data);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  };

  // const handleDCRowClick = (event, type) => {
  //   console.log("Row data:", event.data);
  //   setSelectedRowData({ ...event.data, type });
  //   setCustomOpenModal(true);
  //   setIsEditing(true);
  //   console.log(type, "priceList");
  // };

  const handleDCRowClick = (event, type) => {
    const warehouse = event.data?.Warehouse || "";
    const productCode = event.data?.ProductCode || "";

    // Clear previous price list data before fetching new details
    setGetDcMrpTax(null);

    setCustomOpenModal(true);
    setIsEditing(true);

    // API call
    const apiEndpoint = "/api/getdcpricelistmrptax";
    api
      .post(apiEndpoint, {
        body: {
          Warehouse: warehouse,
          ProductCode: productCode,
          page: "pricelist",
          user: user,
          currencyType: currency,
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);
        setGetDcMrpTax(response.data);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  };

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const handleTabChange = (index) => {
    setActiveTab(index);

    // Reset Filters when switching tabs
    if (gridRef.current) {
      gridRef.current.setFilterModel(null);
      setHasActiveFilters(false); // Reset the filter button visibility
    }
  };

  // Update filter state whenever filters change.
  const onFilterChanged = (params) => {
    const currentFilters = params.api.getFilterModel();
    const isAnyFilterActive = Object.keys(currentFilters).length > 0;
    setHasActiveFilters(isAnyFilterActive);
  };

  //multiPrice-list Edit
  // const handleMultiEdit = () => {
  //   if (gridRef.current) {
  //     const gridApi = gridRef.current.api; // Access the grid API

  //     // Check if any filters are applied
  //     const isFilterApplied = gridApi.isAnyFilterPresent();
  //     if (!isFilterApplied) {
  //       setSnackbarMessage(
  //         "Please apply a filter (e.g., by warehouse or Product) before using multi-edit."
  //       );
  //       setSnackbarSeverity("warning");
  //       setSnackbarOpen(true);
  //       return; // Exit the function if no filters are applied
  //     }

  //     let filteredData = [];

  //     // Use gridApi to loop through filtered nodes
  //     gridApi.forEachNodeAfterFilterAndSort((node) => {
  //       filteredData.push(node.data); // Collect filtered row data
  //     });

  //     // console.log(filteredData, "filteredData 01");

  //     // Check for unique warehouses
  //     const uniqueWarehouses = [
  //       ...new Set(filteredData?.map((item) => item.Warehouse)),
  //     ];
  //     // console.log(uniqueWarehouses, "uniqueWarehouses");

  //     // Check for unique products
  //     const uniqueProducts = [
  //       ...new Set(filteredData?.map((item) => item.Product_Name)),
  //     ];
  //     // console.log(uniqueProducts, "uniqueProducts");

  //     // Validate product selection
  //     if (uniqueProducts.length === 0) {
  //       setSnackbarMessage(
  //         "At least one product must be selected for multi-edit."
  //       );
  //       setSnackbarSeverity("warning");
  //       setSnackbarOpen(true);
  //       return; // Exit the function if no products are selected
  //     }

  //     if (uniqueProducts.length > 4) {
  //       setSnackbarMessage(
  //         "A maximum of 4 unique products can be multi-edited."
  //       );
  //       setSnackbarSeverity("warning");
  //       setSnackbarOpen(true);
  //       return; // Exit the function if more than 4 unique products are selected
  //     }

  //     // Check for unique warehouses (at least 2)
  //     if (uniqueWarehouses?.length >= 2) {
  //       setFilteredData(filteredData); // Set the filtered data state
  //       setMultiEditModel(true); // Open the multi-edit modal
  //       // console.log("Opening multi-edit modal with data:", filteredData);
  //     } else {
  //       setSnackbarMessage(
  //         "At least two warehouses must be filtered for multi-edit."
  //       );
  //       setSnackbarSeverity("warning");
  //       setSnackbarOpen(true);
  //     }
  //   } else {
  //     console.error("Grid API is not available.");
  //   }
  // };

  //[alert handler]
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  //handle close multi model
  const handleMultiModelClose = () => {
    setMultiEditModel(false);
  };


  // update row data
  const updateRowData = (data) => {
    gridRef.current.applyTransaction({ add: data });
    gridRef.current.refreshClientSideRowModel("aggregate");
  };

  // Tab Content
  const tabContents = [
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "5px",
          marginBottom: "20px",
        }}
      >
        <Button
          variant="contained"
          disabled={!isButtonEnabled}
          onClick={() => {
            setCustomOpenModal(true);
            setSelectedRowData(null);
            setIsEditing(false);
          }}
          sx={{
            fontSize: "12px",
            backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
            color: !isButtonEnabled ? "#9e9e9e" : "#fff",
            cursor: !isButtonEnabled ? "not-allowed" : "pointer",
            padding: "8px",
          }}
          size="small"
        >
          <AddIcon
            sx={{
              marginRight: "5px",
            }}
          />
          Add New DC Price
        </Button>

        {/* Clear Filters Button */}
        <div
          style={{
            transition:
              "opacity 0.4s ease-in-out, max-width 0.4s ease-in-out, margin 0.4s ease-in-out",
            opacity: hasActiveFilters ? 1 : 0,
            maxWidth: hasActiveFilters ? "150px" : "0px",
            overflow: "hidden",
            marginLeft: hasActiveFilters ? "10px" : "0px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              if (gridRef.current) {
                gridRef.current.setFilterModel(null);
                gridRef.current.onFilterChanged();
              }
            }}
            style={{
              fontSize: "12px",
              color: "#000",
              borderColor: "#707070",
              whiteSpace: "nowrap",
              padding: "8px",
            }}
            size="small"
          >
            Clear Filters
          </Button>
        </div>
      </Box>

      <Box
        className="ag-theme-quartz price-list-wrapper"
        sx={{ width: "100%", height: "calc(100dvh - 240px)", fontSize: "12px" }}
      >
        {/* DC Price */}
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={DCcolDefs}
          onRowClicked={(event) => handleDCRowClick(event, "DC")}
          onGridReady={onGridReady}
          onFilterChanged={onFilterChanged}
        />
      </Box>
    </Box>,

    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "5px",
          marginBottom: "20px",
        }}
      >
        <Button
          variant="contained"
          disabled={!isButtonEnabled}
          onClick={() => {
            setCustomOpenModal(true);
            setSelectedRowData(null);
            setIsEditing(false);
          }}
          sx={{
            fontSize: "12px",
            backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
            color: !isButtonEnabled ? "#9e9e9e" : "#fff",
            cursor: !isButtonEnabled ? "not-allowed" : "pointer",
            padding: "8px",
          }}
          size="small"
        >
          <AddIcon
            sx={{
              marginRight: "5px",
            }}
          />
          Add New Account Price
        </Button>

        {/* Clear Filters Button */}
        <div
          style={{
            transition:
              "opacity 0.4s ease-in-out, max-width 0.4s ease-in-out, margin 0.4s ease-in-out",
            opacity: hasActiveFilters ? 1 : 0,
            maxWidth: hasActiveFilters ? "150px" : "0px",
            overflow: "hidden",
            marginLeft: hasActiveFilters ? "10px" : "0px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              if (gridRef.current) {
                gridRef.current.setFilterModel(null);
                gridRef.current.onFilterChanged();
              }
            }}
            style={{
              fontSize: "12px",
              color: "#000",
              borderColor: "#707070",
              whiteSpace: "nowrap",
              padding: "8px",
            }}
            size="small"
          >
            Clear Filters
          </Button>
        </div>
      </Box>

      <Box
        className="ag-theme-quartz price-list-wrapper"
        sx={{ width: "100%", height: "calc(100dvh - 240px)", fontSize: "12px" }}
      >
        {/* Account price */}
        <AgGridReact
          ref={gridRef}
          rowData={rowData01}
          columnDefs={AccountColDefs}
          onRowClicked={(event) => handleRowClick(event, "Account")}
          onGridReady={onGridReady}
          onFilterChanged={onFilterChanged}
        />
      </Box>
    </Box>,
  ];

  return (
    <>
      {(loading || loadingSpinner) && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <LoadingSpinner />
          </div>
        </div>
      )}
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            flexGrow: 1,
            marginLeft: open ? "240px" : "0",
            transition: "margin-left 0.3s",
            padding: "16px",
          }}
        >
          <TabComp
            tabs={tabLabels}
            contents={tabContents}
            indicatorBackgroundColor="#138F81"
            TextColor=""
            SelectedTextColor="#138F81"
            HoverTextColor="#138F81"
            onChange={(index, event, newValue) => {
              setActiveTab(index);
              handleTabChange(index);
            }}
          />
        </Box>

        <AddNewPricelist
          open={customOpenModal}
          setCustomOpenModal={setCustomOpenModal}
          handleClose={closeModal}
          selectedRowData={selectedRowData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          data={editingValue}
          updateRowData={updateRowData}
          shouldDisableDate={true}
          priceListUpdateButton={
            activeTab === 0 ? "Update DC Price" : "Update Account Price"
          }
          getDcMrpTax={getDcMrpTax}
        />

        <MultiplePriceListEdit
          open={multiEditModel}
          setMultiEditModel={setMultiEditModel}
          handleMultiModelClose={handleMultiModelClose}
          filteredRows={filteredData}
          // updateRowData={updateRowData}
          isAccountTab={activeTab === 1}
          selectedRowData={selectedRowData}
          priceListResponse={priceListResponse}
        />

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}

export default Pricelist;
